const global = {
	sb_title: "XL3",
	sb_main_menu: "Hovedmeny",
	sb_manage_menu: "Håndter",
	sb_admin_menu: "Administrasjon",
	sb_template_menu: "Malverk",
	sb_more_menu: "Mer",
	manuals: "Manualer",
	my_profile: "Min Profil",
	new: "Ny",
	edit: "Rediger",
	view: "Vis",
	preview: "Forhåndsvis",
	preview_not_available: "Forhåndsvisning ikke tilgjengelig",
	delete: "Slett",
	delete_selected: "Slett valgte",
	remove: "Fjern",
	save: "Lagre",
	save_send: "Lagre og send",
	save_without_notification: "Lagre uten varsling",
	notify: "Varsling",
	send: "Send",
	cancel: "Avbryt",
	back: "Tilbake",
	actions: "Valg",
	copy: "Kopiere",
	move: "Flytte",
	copy_to_kursweb: "Kopier til interne dok.",
	copy_to_kompetanse: "Kopier til elev dok.",
	move_to_kursweb: "Flytt til interne dok.",
	move_to_kompetanse: "Flyt til elev dok.",
	filter: "Filter",
	show_filter: "Vis filter",
	hide_filter: "Skjul filter",
	clear: "Rens",
	reset: "Tilbakestill",
	restore: "Gjennopprett",
	start: "Start",
	stop: "Stopp",
	pdf: "PDF",
	close: "Lukk",
	merge: "Slå sammen",
	verify: "Verifisér",
	add: "Legg til",
	select: "Velg",
	select_all: "Alle",
	show_all: "Vis alle",
	none_select: "Ingen tilvalg",
	ok: "OK",
	capture: "Ta bilde",
	match_grade: "Match grade",
	from_file: "Last opp fil",
	from_digital_signature: "Signer digitalt",
	from_camera: "Fra kamera",
	switchcamera: "Bytt kamera",
	upload: "Last opp",
	download: "Last ned",
	search: "Søk",
	search_start_here: "Start søk her",
	crop_and_upload: "Last opp",
	validate: "Verifiser",
	export_excel: "Eksporter til Excel (XLSX)",
	get_templates: "Hent maler",
	import: "Import",
	refresh: "Oppdater",
	something_went_wrong: "Det har oppstått en feil. Ta kontakt med administratoren.",
	added_date: "Lagt til",
	updated_date: "Oppdatert",
	deleted_date: "Slettet",
	create_success: "Ny data er lagt til",
	create_failed: "Registering feilet",
	update_success: "Vellykket oppdatering",
	update_failed: "Oppdatering feilet",
	delete_message: "Vil du slette?",
	delete_success: "Sletting utført",
	delete_failed: "Sletting feilet",
	setting_updated_success: "Instillinger oppdatert",
	setting_updated_failed: "Oppdatering av innstillinger feilet",
	delete_file_success: "Fil slettet",
	delete_file_failed: "Klarte ikke slette fil",
	copy_file_success: "Dokumenter ble kopiert",
	move_file_success: "Dokumenter ble flyttet",
	restore_success: "Filen/dokumentet ble gjenopprettet",
	restore_failed: "Filen/dokumentet kunne ikke gjenopprettes",
	save_changes: "Vil du lagre endringene?",
	discard_changes: "Vil du forkaste endringene?",
	confirm_message: "Vennligst bekreft",
	redirecting_to: "Sender videre til",
	invalid_short_url: "Ugyldig URL",
	more: "Mer",
	copied: "Kopiert",
	yes: "Ja",
	no: "Nei",
	welcome: "Velkommen",
	view_history: "Vis historikk",
	checked: "Lagt til",
	unchecked: "Fjernet",
	drop_files_here: "Slip fil(er) her",
	no_locale: "Oversettelsen på {locale} er ikke tilgjengelig",
	change_locale: "Språk endret",
	change_locale_refresh: "Siden må lastes inn på nytt for å endre språk",
	available: "Tilgjengelig",
	not_available: "Ikke tilgjengelig",
	helptext_vat: "Gyldig organisasjons nr. 9 siffer, uten mellomrom",
	helptext_password: "Min. 8 tegn, bestående av: stor bokstav, liten bokstav, tall",
	location: "Opprettet",
	location_admin: "Admin mal",
	location_local: "Lokal mal",
	last_updated_by: "Sist oppdatert:",
	xl3_admin: "XL3 Admin",
	show_more: "Vis mer",
	show_less: "Vis mindre",
	new_version: "Oppdatering er tilgjengelig. Klikk \"Oppdater\"",
	no_permission_title: "Tilgang nektet",
	no_permission_text: "Du har ikke tilgang til å vise denne siden",
	error_tenant_inactive: "Klient er inaktiv",
	not_available_seats: "Antall plasser er lavere enn valgt antall elever",
	email_already_in_use_by_tenant: "Epost er allerede i bruk.",
	email_already_in_use: "Epost er allerede registrert i XL3",
	form_not_valid: "Endringene er ikke lagret. Vennligst sjekk obligatoriske felt.",
	loading_text: "Laster inn...",
	no_data_text: "Listen er tom",
	no_data_create: "Fant ingenting. Trykk Enter for å opprette.",
	no_results_text: "Ingenting funnet",
	items_per_page_all_text: "Alle",
	items_per_page_text: "Per side:",
	page_text: "{0}-{1} av {2}",
	processing: "Jobber. Venligst vent...",
	see_more: "Se mer",
	dd_modules_calendar: "Kalender",
	dd_modules_users: "Brukere",
	dd_modules_roles: "Roller",
	dd_modules_permissions: "Tillatelser",
	dd_modules_organisations: "Organisasjoner",
	dd_modules_courses: "Kurs",
	dd_modules_coursetemplates: "Kurs maler",
	dd_modules_coursetypegroups: "Kompetanseområde",
	dd_modules_coursetypes: "Opplæringstype",
	dd_modules_checklisttemplates: "Sjekklistemaler",
	dd_modules_tasks: "Oppgaver",
	dd_modules_drivingtests: "Oppkjøringsklasser",
	dd_modules_settings: "Innstillinger",
	dd_modules_class: "Klasse",
	dd_modules_logs: "Logger",
	dd_modules_queues: "Kø",
	dd_modules_addresses: "Adresser",
	dd_modules_persons: "Kontakter",
	dd_modules_classrooms: "Klasserom",
	dd_modules_certificate: "Sertifikater",
	dd_modules_enrolments: "Påmeldinger",
	dd_modules_participants: "Deltagere",
	dd_modules_attendees: "Fremmøtte",
	dd_modules_moduletemplates: "Modulmaler",
	dd_modules_customergroups: "Kundegrupper",
	dd_modules_studentgroups: "Elevgrupper",
	dd_modules_educationprograms: "Utdanningsprogram",
	dd_modules_reports: "Rapporter",
	dd_modules_passports: "API Klienter",
	dd_locales_en: "English",
	dd_locales_no: "Norsk (bokmål)",
	dd_locales_nn: "Norsk (nynorsk)",
	dd_user_status_inactive: "Inaktiv",
	dd_user_status_active: "Aktiv",
	dd_user_status_force_change: "Tving passordendring",
	dd_course_status_upcoming: "Kommende",
	dd_course_status_onhold: "Avvent",
	dd_course_status_archived: "Arkivert",
	dd_course_status_final: "Avsluttet",
	dd_course_status_cancelled: "Kansellert",
	dd_course_status_ongoing: "Pågående",
	dd_course_quick_filter_my_courses: "Mine kurs",
	dd_course_quick_filter_unassigned: "Ikke tildelt",
	dd_course_quick_filter_all: "Alle",
	dd_task_status_inactive: "Inaktiv",
	dd_task_status_active: "Aktiv",
	dd_drivingtest_status_inactive: "Inaktiv",
	dd_drivingtest_status_available: "Tilgjengelig",
	dd_drivingtest_status_agreed: "Avtalt",
	dd_drivingtest_status_archived: "Arkivert",
	dd_titles_mr: "Herr",
	dd_titles_mrs: "Fru",
	dd_titles_ms: "Frøken",
	dd_course_templates_status_inactive: "Inaktiv",
	dd_course_templates_status_active: "Aktiv",
	dd_admin_course_templates_filter_new_and_updated: "Nye og oppdaterte",
	dd_admin_course_templates_filter_all: "Alle maler",
	dd_module_templates_status_inactive: "Inaktiv",
	dd_module_templates_status_active: "Aktiv",
	dd_admin_module_templates_filter_new_and_updated: "Nye og oppdaterte",
	dd_admin_module_templates_filter_all: "Alle maler",
	dd_course_templates_type_certified: "Sertifisert opplæring",
	dd_course_templates_type_documented: "Dokumentert opplæring",
	dd_course_templates_type_undocumented: "Annen opplæring",
	dd_course_template_types_documented: "Dokumentert",
	dd_course_template_types_certified: "Sertifisert",
	dd_course_template_types_hotwork: "Varmt arbeid",
	dd_course_template_types_instructor_documented: "Kursholder bekreftet",
	dd_course_template_types_controller: "Kontrollør",
	dd_course_template_types_other: "Annet",
	dd_course_templates_type_normal: "Kursmal",
	dd_course_templates_type_long: "Opplæringsløp",
	dd_course_type_groups_status_inactive: "Inaktiv",
	dd_course_type_groups_status_active: "Aktiv",
	dd_course_type_groups_type_certified: "Sertifisert opplæring",
	dd_course_type_groups_type_documented: "Dokumentert opplæring",
	dd_course_type_groups_type_undocumented: "Annen opplæring",
	dd_course_types_status_inactive: "Inaktiv",
	dd_course_types_status_active: "Aktiv",
	dd_checklisttemplate_checkliststatus_draft: "Utkast",
	dd_checklisttemplate_checkliststatus_completed: "Ferdig",
	dd_checklisttemplate_checkliststatus_archived: "Arkivert",
	dd_checklisttemplate_checklisttype_service: "Servicejobb",
	dd_checklisttemplate_checklisttype_control: "Kontrollrapport",
	dd_checklisttemplate_checklisttype_daily: "Daglig kontroll",
	dd_checklisttemplate_checklisttype_brakomp: "XL3 skjemaer",
	dd_classes_status_inactive: "Inaktiv",
	dd_classes_status_active: "Aktiv",
	dd_classes_duration_type_min: "Min",
	dd_classes_duration_type_hours: "Timer",
	dd_addresses_status_not_available: "Inaktiv",
	dd_addresses_status_available: "Aktiv",
	dd_classroom_status_not_available: "Inaktiv",
	dd_classroom_status_available: "Tilgjengelig",
	dd_moduletemplate_type_joint: "Felles",
	dd_moduletemplate_type_per_course: "Per kurstype",
	dd_moduletemplate_template_type_certified: "Sertifisert opplæring",
	dd_moduletemplate_template_type_documented: "Dokumentert opplæring",
	dd_moduletemplate_template_type_undocumented: "Annen opplæring",
	dd_customer_group_status_inactive: "Inaktiv",
	dd_customer_group_status_active: "Aktiv",
	dd_education_program_status_inactive: "Inaktiv",
	dd_education_program_status_active: "Aktiv  ",
	dd_student_group_status_inactive: "Inaktiv",
	dd_student_group_status_active: "Aktiv",
	dd_attendees_theory_test_na: "IA",
	dd_attendees_theory_test_passed: "Bestått",
	dd_attendees_theory_test_failed: "Ikke bestått",
	dd_tennant_sms_service_active: "Aktiv",
	dd_tennant_sms_service_inactive: "Inaktiv",
	dd_enrolment_status_inactive: "Inaktiv",
	dd_enrolment_status_active: "Aktiv",
	dd_enrolment_status_did_not_meet: "Ikke møtt",
	dd_enrolment_status_request: "Interesserte",
	dd_enrolment_status_cancelled: "Kansellert",
	dd_enrolment_list_status_all: "Alle",
	dd_enrolment_list_status_active: "Aktive",
	dd_enrolment_list_status_cancelled: "Kansellert",
	dd_enrolment_list_status_requests: "Interesserte",
	dd_chart_period_filter_last_3months: "3 måneder",
	dd_chart_period_filter_last_6months: "6 måneder",
	dd_chart_period_filter_last_12months: "12 måneder",
	dd_notificationtemplate_type_email: "Epost",
	dd_notificationtemplate_type_sms: "SMS",
	dd_inspection_interval_daily: "Daglig",
	dd_inspection_interval_weekly: "Ukentlig",
	dd_inspection_interval_14day: "Hver 14.dag",
	dd_inspection_interval_monthly: "Månedlig",
	dd_inspection_interval_quarter: "3 mndr.",
	dd_inspection_interval_semiannual: "6 mndr.",
	dd_inspection_interval_annual: "12 mndr.",
	dd_select_visibility_no_choice: "Ikke vis",
	dd_select_visibility_expertise: "Vis i kompetanse",
	dd_select_visibility_course_certificate: "Vis i kursbevis",
	dd_select_visibility_both: "Vis i begge",
	dd_klarna_checkout_type_personal: "Kun for privat private",
	dd_klarna_checkout_type_organisation: "Kun for organisasjoner",
	dd_klarna_checkout_type_both: "Begge",
	dd_course_enrolment_status_enrolled: "Påmeldt",
	dd_course_enrolment_status_attending: "Deltar",
	dd_course_enrolment_status_completed: "Fullført",
	dd_course_enrolment_status_requested: "Interesserte",
	dd_course_enrolment_status_did_not_meet: "Kansellert",
	dd_course_enrolment_status_cancelled: "Ikke møtt",
	dd_countries_AFG: "Afghanistan",
	dd_countries_ALA: "Aland Islands",
	dd_countries_ALB: "Albania",
	dd_countries_DZA: "Algerie",
	dd_countries_ASM: "American Samoa",
	dd_countries_AND: "Andorra",
	dd_countries_AGO: "Angola",
	dd_countries_AIA: "Anguilla",
	dd_countries_ATA: "Antartica",
	dd_countries_ATG: "Antigua og Barbuda",
	dd_countries_ARG: "Argentina",
	dd_countries_ARM: "Armenia",
	dd_countries_ABW: "Aruba",
	dd_countries_AUS: "Australia",
	dd_countries_AUT: "Østerrike",
	dd_countries_AZE: "Aserbajdsjan",
	dd_countries_BHS: "Bahamas",
	dd_countries_BHR: "Bahrain",
	dd_countries_BGD: "Bangladesh",
	dd_countries_BRB: "Barbados",
	dd_countries_BLR: "Hviterussland",
	dd_countries_BEL: "Belgia",
	dd_countries_BLZ: "Belize",
	dd_countries_BEN: "Benin",
	dd_countries_BMU: "Bermuda",
	dd_countries_BTN: "Bhutan",
	dd_countries_BOL: "Bolivia, Plurinational State of",
	dd_countries_BES: "Bonaire, Sint Eustatius and Saba",
	dd_countries_BIH: "Bosnia and Herzegovina",
	dd_countries_BWA: "Botswana",
	dd_countries_BVT: "Bouvet Island",
	dd_countries_BRA: "Brazil",
	dd_countries_IOT: "British Indian Ocean Territory",
	dd_countries_BRN: "Brunei Darussalam",
	dd_countries_BGR: "Bulgaria",
	dd_countries_BFA: "Burkina Faso",
	dd_countries_BDI: "Burundi",
	dd_countries_KHM: "Cambodia",
	dd_countries_CMR: "Cameroon",
	dd_countries_CAN: "Canada",
	dd_countries_CPV: "Cape Verde",
	dd_countries_CYM: "Cayman Islands",
	dd_countries_CAF: "Central African Republic",
	dd_countries_TCD: "Chad",
	dd_countries_CHL: "Chile",
	dd_countries_CHN: "China",
	dd_countries_CXR: "Christmas Island",
	dd_countries_CCK: "Cocos (Keeling) Islands",
	dd_countries_COL: "Colombia",
	dd_countries_COM: "Comoros",
	dd_countries_COG: "Congo",
	dd_countries_COD: "Congo, the Democratic Republic of the",
	dd_countries_COK: "Cook Islands",
	dd_countries_CRI: "Costa Rica",
	dd_countries_CIV: "Côte d'Ivoire",
	dd_countries_HRV: "Croatia",
	dd_countries_CUB: "Cuba",
	dd_countries_CUW: "Curaçao",
	dd_countries_CYP: "Cyprus",
	dd_countries_CZE: "Czech Republic",
	dd_countries_DNK: "Danmark",
	dd_countries_DJI: "Djibouti",
	dd_countries_DMA: "Dominica",
	dd_countries_DOM: "Den dominikanske republikk",
	dd_countries_ECU: "Ecuador",
	dd_countries_EGY: "Egypt",
	dd_countries_SLV: "El Salvador",
	dd_countries_GNQ: "Equatorial Guinea",
	dd_countries_ERI: "Eritrea",
	dd_countries_EST: "Estland",
	dd_countries_ETH: "Ethiopia",
	dd_countries_FLK: "Falkland Islands (Malvinas)",
	dd_countries_FRO: "Faroe Islands",
	dd_countries_FJI: "Fiji",
	dd_countries_FIN: "Finland",
	dd_countries_FRA: "Frankrike",
	dd_countries_GUF: "French Guiana",
	dd_countries_PYF: "French Polynesia",
	dd_countries_ATF: "French Southern Territories",
	dd_countries_GAB: "Gabon",
	dd_countries_GMB: "Gambia",
	dd_countries_GEO: "Georgia",
	dd_countries_DEU: "Tyskland",
	dd_countries_GHA: "Ghana",
	dd_countries_GIB: "Gibraltar",
	dd_countries_GRC: "Greece",
	dd_countries_GRL: "Greenland",
	dd_countries_GRD: "Grenada",
	dd_countries_GLP: "Guadeloupe",
	dd_countries_GUM: "Guam",
	dd_countries_GTM: "Guatemala",
	dd_countries_GGY: "Guernsey",
	dd_countries_GIN: "Guinea",
	dd_countries_GNB: "Guinea-Bissau",
	dd_countries_GUY: "Guyana",
	dd_countries_HTI: "Haiti",
	dd_countries_HMD: "Heard Island and McDonald Islands",
	dd_countries_VAT: "Holy See (Vatican City State)",
	dd_countries_HND: "Honduras",
	dd_countries_HKG: "Hong Kong",
	dd_countries_HUN: "Hungary",
	dd_countries_ISL: "Iceland",
	dd_countries_IND: "India",
	dd_countries_IDN: "Indonesia",
	dd_countries_IRN: "Iran, Islamic Republic of",
	dd_countries_IRQ: "Iraq",
	dd_countries_IRL: "Ireland",
	dd_countries_IMN: "Isle of Man",
	dd_countries_ISR: "Israel",
	dd_countries_ITA: "Italy",
	dd_countries_JAM: "Jamaica",
	dd_countries_JPN: "Japan",
	dd_countries_JEY: "Jersey",
	dd_countries_JOR: "Jordan",
	dd_countries_KAZ: "Kazakhstan",
	dd_countries_KEN: "Kenya",
	dd_countries_KIR: "Kiribati",
	dd_countries_PRK: "Korea, Democratic People's Republic of",
	dd_countries_KOR: "Korea, Republic of",
	dd_countries_KWT: "Kuwait",
	dd_countries_KGZ: "Kyrgyzstan",
	dd_countries_LAO: "Lao People's Democratic Republic",
	dd_countries_LVA: "Latvia",
	dd_countries_LBN: "Lebanon",
	dd_countries_LSO: "Lesotho",
	dd_countries_LBR: "Liberia",
	dd_countries_LBY: "Libya",
	dd_countries_LIE: "Liechtenstein",
	dd_countries_LTU: "Lithuania",
	dd_countries_LUX: "Luxembourg",
	dd_countries_MAC: "Macao",
	dd_countries_MKD: "Macedonia, the former Yugoslav Republic of",
	dd_countries_MDG: "Madagascar",
	dd_countries_MWI: "Malawi",
	dd_countries_MYS: "Malaysia",
	dd_countries_MDV: "Maldives",
	dd_countries_MLI: "Mali",
	dd_countries_MLT: "Malta",
	dd_countries_MHL: "Marshall Islands",
	dd_countries_MTQ: "Martinique",
	dd_countries_MRT: "Mauritania",
	dd_countries_MUS: "Mauritius",
	dd_countries_MYT: "Mayotte",
	dd_countries_MEX: "Mexico",
	dd_countries_FSM: "Micronesia, Federated States of",
	dd_countries_MDA: "Moldova, Republic of",
	dd_countries_MCO: "Monaco",
	dd_countries_MNG: "Mongolia",
	dd_countries_MNE: "Montenegro",
	dd_countries_MSR: "Montserrat",
	dd_countries_MAR: "Morocco",
	dd_countries_MOZ: "Mozambique",
	dd_countries_MMR: "Myanmar",
	dd_countries_NAM: "Namibia",
	dd_countries_NRU: "Nauru",
	dd_countries_NPL: "Nepal",
	dd_countries_NLD: "Netherlands",
	dd_countries_NCL: "New Caledonia",
	dd_countries_NZL: "New Zealand",
	dd_countries_NIC: "Nicaragua",
	dd_countries_NER: "Niger",
	dd_countries_NGA: "Nigeria",
	dd_countries_NIU: "Niue",
	dd_countries_NFK: "Norfolk Island",
	dd_countries_MNP: "Northern Mariana Islands",
	dd_countries_NOR: "Norge",
	dd_countries_OMN: "Oman",
	dd_countries_PAK: "Pakistan",
	dd_countries_PLW: "Palau",
	dd_countries_PSE: "Palestinian Territory, Occupied",
	dd_countries_PAN: "Panama",
	dd_countries_PNG: "Papua New Guinea",
	dd_countries_PRY: "Paraguay",
	dd_countries_PER: "Peru",
	dd_countries_PHL: "Philippines",
	dd_countries_PCN: "Pitcairn",
	dd_countries_POL: "Poland",
	dd_countries_PRT: "Portugal",
	dd_countries_PRI: "Puerto Rico",
	dd_countries_QAT: "Qatar",
	dd_countries_REU: "Réunion",
	dd_countries_ROU: "Romania",
	dd_countries_RUS: "Russian Federation",
	dd_countries_RWA: "Rwanda",
	dd_countries_BLM: "Saint Barthélemy",
	dd_countries_SHN: "Saint Helena, Ascension and Tristan da Cunha",
	dd_countries_KNA: "Saint Kitts and Nevis",
	dd_countries_LCA: "Saint Lucia",
	dd_countries_MAF: "Saint Martin (French part)",
	dd_countries_SPM: "Saint Pierre and Miquelon",
	dd_countries_VCT: "Saint Vincent and the Grenadines",
	dd_countries_WSM: "Samoa",
	dd_countries_SMR: "San Marino",
	dd_countries_STP: "Sao Tome and Principe",
	dd_countries_SAU: "Saudi Arabia",
	dd_countries_SEN: "Senegal",
	dd_countries_SRB: "Serbia",
	dd_countries_SYC: "Seychelles",
	dd_countries_SLE: "Sierra Leone",
	dd_countries_SGP: "Singapore",
	dd_countries_SXM: "Sint Maarten (Dutch part)",
	dd_countries_SVK: "Slovakia",
	dd_countries_SVN: "Slovenia",
	dd_countries_SLB: "Solomon Islands",
	dd_countries_SOM: "Somalia",
	dd_countries_ZAF: "South Africa",
	dd_countries_SGS: "South Georgia and the South Sandwich Islands",
	dd_countries_SSD: "South Sudan",
	dd_countries_ESP: "Spain",
	dd_countries_LKA: "Sri Lanka",
	dd_countries_SDN: "Sudan",
	dd_countries_SUR: "Suriname",
	dd_countries_SJM: "Svalbard and Jan Mayen",
	dd_countries_SWZ: "Swaziland",
	dd_countries_SWE: "Sverige",
	dd_countries_CHE: "Switzerland",
	dd_countries_SYR: "Syrian Arab Republic",
	dd_countries_TWN: "Taiwan, Province of China",
	dd_countries_TJK: "Tajikistan",
	dd_countries_TZA: "Tanzania, United Republic of",
	dd_countries_THA: "Thailand",
	dd_countries_TLS: "Timor-Leste",
	dd_countries_TGO: "Togo",
	dd_countries_TKL: "Tokelau",
	dd_countries_TON: "Tonga",
	dd_countries_TTO: "Trinidad and Tobago",
	dd_countries_TUN: "Tunisia",
	dd_countries_TUR: "Tyrkia",
	dd_countries_TKM: "Turkmenistan",
	dd_countries_TCA: "Turks and Caicos Islands",
	dd_countries_TUV: "Tuvalu",
	dd_countries_UGA: "Uganda",
	dd_countries_UKR: "Ukraina",
	dd_countries_ARE: "United Arab Emirates",
	dd_countries_GBR: "Storbritania",
	dd_countries_USA: "USA",
	dd_countries_UMI: "United States Minor Outlying Islands",
	dd_countries_URY: "Uruguay",
	dd_countries_UZB: "Usbekistan",
	dd_countries_VUT: "Vanuatu",
	dd_countries_VEN: "Venezuela",
	dd_countries_VNM: "Vietnam",
	dd_countries_VGB: "Virgin Islands, British",
	dd_countries_VIR: "Virgin Islands, U.S.",
	dd_countries_WLF: "Wallis and Futuna",
	dd_countries_ESH: "Western Sahara",
	dd_countries_YEM: "Yemen",
	dd_countries_ZMB: "Zambia",
	dd_countries_ZWE: "Zimbabwe",
};
export default global;